<script>
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'
import { mapGetters } from 'vuex'
/*
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
*/

export default
{
    components: { VueEditor },

    computed:
    {
        categoryValue:
        {
            get()
            {
                return this.categories.findByModelId(this.model.post_category_id)
            },

            set(val)
            {
                if (val && val.id)
                    this.model.post_category_id = val.id
            },
        },

        ...mapGetters({ locale: 'generalCurrentLocale'}),

    },

    methods:
    {
        save()
        {
            if (this.edit)
            {
                this.$api('put', `/v1/admin/posts/${this.$route.params.id}`, this.model, {
                    title: '',
                    body: this.$t('GENERAL.SAVING'),
                    success: this.$t('GENERAL.SAVED'),
                }).then(() => {
                    this.goToPosts()
                })
            } else {
                this.$api('post', '/v1/admin/posts', this.model, {
                    title: '',
                    body: this.$t('GENERAL.SAVING'),
                    success: this.$t('GENERAL.SAVED'),
                }).then(() => {
                    this.goToPosts()
                })
            }
        },

        goToPosts()
        {
            this.$router.push('/posts')
        },

        fetchCategories()
        {
            axios.get(process.env.API_URL + '/v1/admin/postcategories').then(({data}) => {
                this.categories = data
            })
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        locAddressChange(obj)
        {
            this.model.location = obj
        },

    },

    mounted()
    {
        if (this.$route.params.id)
        {
            axios.get(process.env.API_URL + `/v1/admin/posts/${this.$route.params.id}`).then(({ data }) => {
                this.edit = true
                this.model = data
            })
        }
        this.fetchCategories()
    },

    data()
    {
        return {
            categories: [],
            edit: false,
            model: {
                title: null,
                type: 'info',
                title_en: null,
                post_category_id: null,
                excerpt: null,
                excerpt_en: null,
                slug: null,
                content: null,
                content_en: null,
                address: null,
                phone: null,
                mail: null,
                attachments: [],
                location: null,
            },
            editorSettings: {
                imageResize: {},
            },
        }
    },

}
</script>

<template>
<div class="container">

    <div class="panel panel-primary">
        <div class="panel-heading">
            <div>{{ $t('POST.POST') }}</div>
        </div>
        <div class="panel-body">
            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.TITLE') }}
                </label>
                <div class="col-md-10">
                    <input type="text" class="form-control" v-model="model.title" v-if="locale == 'hu'">
                    <input type="text" class="form-control" v-model="model.title_en" v-else>
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.SLUG') }}
                </label>
                <div class="col-md-10">
                    <input type="text" class="form-control" v-model="model.slug">
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.ORDER') }}
                </label>
                <div class="col-md-10">
                    <input type="number" class="form-control" v-model="model.order">
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.EXCERPT') }}
                </label>
                <div class="col-md-10">
                    <textarea v-model="model.excerpt" class="form-control" rows="4" v-if="locale == 'hu'">

                    </textarea>
                    <textarea v-model="model.excerpt_en" class="form-control" rows="4" v-else>

                    </textarea>
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.CATEGORY') }}
                </label>
                <div class="col-md-10">
                    <v-select :options="categories" v-model="categoryValue" label="name">
                        <template slot="option" slot-scope="option">
                            <div class="row option-row">
                                <div class="col-sm-12">
                                    <div class="text">
                                        {{ option.name }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-2 control-label">
                    {{ $t('GENERAL.IMAGES') }}
                </label>
                <div class="col-md-10">
                    <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*" ></mv-image-uploader>
                    <label class="btn btn-sm btn-primary">
                        <mv-uploader multiple @upload-done="addFile($event)" accept="image/*"></mv-uploader>
                        <icon name="picture-o"></icon>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-2">

                </div>
                <div class="col-md-10">
                    <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                    </mv-attachment>
                </div>
            </div>

            <div class="form-group row" v-if="false">
                <label class="col-md-2 control-label">
                    {{ $t('PLACE.ADDRESS_SEARCH') }}
                </label>
                <div class="col-md-10">
                    <mv-address @locationChange="locAddressChange"></mv-address>
                </div>
            </div>

            <div class="form-group row" v-if="false">
                <label class="col-md-2 control-label">
                    {{ $t('PLACE.LOCATION') }}
                </label>
                <div class="col-md-10">
                    <mv-map v-model="model.location"></mv-map>
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.ADDRESS') }}
                </label>
                <div class="col-md-10">
                    <input type="text" class="form-control" v-model="model.address">
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.PHONE') }}
                </label>
                <div class="col-md-10">
                    <input type="text" class="form-control" v-model="model.phone">
                </div>
            </div>

            <div class="form-group row">
                <label for="name" class="col-md-2 control-label">
                    {{ $t('POST.MAIL') }}
                </label>
                <div class="col-md-10">
                    <input type="text" class="form-control" v-model="model.mail">
                </div>
            </div>

            <vue-editor
                v-if="locale == 'hu'"
                :editorOptions="editorSettings"
                v-model="model.content">
                </vue-editor>

            <vue-editor
                v-if="locale == 'en'"
                :editorOptions="editorSettings"
                v-model="model.content_en">
                </vue-editor>

        </div>

        <div class="panel-footer">
            <div class="text-right">
                <button class="btn btn-primary">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-success" @click="save">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </div>
    </div>



</div>
</template>



// WEBPACK FOOTER //
// src/pages/PostEditor.vue